module.exports = __webpack_public_path__ + "static/media/home.a86860af.jpg";